import { Component, Input, OnInit } from '@angular/core';
import { marketGuidesEnabled } from 'src/app/site-config';
import { guidePath, MarketGuidesService, Publication } from '../market-guides.service';

/**
 * A restrained band featuring the latest Market Guide: its cover, title and
 * one link to the guide page. On the homepage it shows only while the guide's
 * complimentary launch is open; on Insights & Opinion (/blog) it always shows.
 * Renders nothing where Market Guides is switched off.
 */
@Component({
  selector: 'pla-guide-feature',
  templateUrl: './guide-feature.component.html',
  styleUrls: ['./guide-feature.component.scss'],
})
export class GuideFeatureComponent implements OnInit {
  @Input() placement: 'home' | 'insights' = 'insights';

  public guide: Publication | null = null;
  public readonly path = guidePath;

  constructor(private service: MarketGuidesService) {}

  ngOnInit(): void {
    if (!marketGuidesEnabled) return;
    this.service.list().subscribe({
      next: (list) => {
        const g = list[0] || null;
        if (!g) return;
        if (this.placement === 'home' && g.phase !== 'complimentary') return;
        this.guide = g;
      },
      error: () => {},
    });
  }

  get cta(): string {
    if (!this.guide) return '';
    if (this.guide.access.entitled) return 'Read the guide';
    return this.guide.phase === 'complimentary' ? 'Claim your free copy' : 'View the guide';
  }
}
